import { PSMS_AUDIT_REASON_CODE_DATA_REQUEST, PSMS_EVAlUATION_DETAILS_DATA_REQUEST, PSMS_PAYMENT_INTEGRITY_DATA_REQUEST } from "@src/middleware/actions/actionTypes";
import { getAuditReasonCodeDataLoading, getAuditReasonCodeDataSuccess, getPSMSEvaluationDetailsDataLoading, getPSMSEvaluationDetailsDataSuccess, getPSMSPaymentIntegrityDataSuccess, getPSMSPaymentIntegrityDataFailure, getPSMSPaymentIntegrityLoading } from "@src/middleware/actions/psms/paymentIntegrityActions";
import { getAuditReasonCodes, getPSMSEvaluationDetails, getPSMSPaymentIntegritySummaryData } from "@src/middleware/services/psms/PaymentIntegrity.service";
import { call, put, takeLatest } from "redux-saga/effects";

export function* fetchPSMSPaymentIntegritySummaryData(action: any) {
  const payload = action?.payload || {};
  yield put(getPSMSPaymentIntegrityLoading(true));
  try {
    const response = yield call(getPSMSPaymentIntegritySummaryData, payload);
    yield put(getPSMSPaymentIntegrityDataSuccess(response?.Data[0]));
  } catch (error: any) {
    yield put(getPSMSPaymentIntegrityDataFailure(error));
  } finally {
    yield put(getPSMSPaymentIntegrityLoading(false));
  }
}

export function* fetchPSMSEvaluationDetailsData(action: any) {
  const payload = action?.payload || {};
  yield put(getPSMSEvaluationDetailsDataLoading(true));
  try {
    const response = yield call(getPSMSEvaluationDetails, payload);
    yield put(getPSMSEvaluationDetailsDataSuccess(response));
  } catch (error: any) {
    yield put(getPSMSEvaluationDetailsDataLoading(false));
  } finally {
    yield put(getPSMSEvaluationDetailsDataLoading(false));
  }
}


export function* fetchPSMSAuditReasonCodeData(action: any) {
  const payload = action?.payload || {};
  yield put(getAuditReasonCodeDataLoading(true));
  try {
    const response = yield call(getAuditReasonCodes, payload);
    yield put(getAuditReasonCodeDataSuccess(response?.Data || []));
  } catch (error: any) {
    yield put(getAuditReasonCodeDataLoading(false));
  } finally {
    yield put(getAuditReasonCodeDataLoading(false));
  }
}


export function* paymentIntegritySaga() {
  yield takeLatest(PSMS_PAYMENT_INTEGRITY_DATA_REQUEST, fetchPSMSPaymentIntegritySummaryData);
  yield takeLatest(PSMS_EVAlUATION_DETAILS_DATA_REQUEST, fetchPSMSEvaluationDetailsData);
  yield takeLatest(PSMS_AUDIT_REASON_CODE_DATA_REQUEST, fetchPSMSAuditReasonCodeData);
}

